<template lang="pug">
    #tabs(ref="container" class="mt-3")
        div(class="wrapper h-16")
            #tabHeader(ref="header" class="tabs-header bg-gray-lighter border-none")
                ul(class="list flex")
                    li(@click="selectTab('Top')" class="item _onlyFixed p-3 mr-3 cursor-pointer text-center hidden")
                        div(class="text-sm text-dark uppercase font-bold xs:text-base hover:no-underline") Top
                    li(
                        v-for="(props,index) in tabsArray",
                        ref="links",
                        @click="selectTab(index)"
                        class="item p-3 mr-3 cursor-pointer text-center"
                    )
                        div(class="text-sm text-dark uppercase font-bold xs:text-base hover:no-underline") {{ props.name }}
                div(class="wrapper h-1 bg-gray-lighter")
                    .slider(ref="slide" class="absolute bottom-0 bg-primary h-1 border-none transition-all duration-300 ease-in")
        div(class="content pt-4 pb-6")
            Tab(
                v-for="(props,index) in tabsArray"
                ref="tabs"
                :key="`tab-${index}`"
                :name="props.name"
                :selected="(alwaysShowTabs || index === getSelectedTabIndex)"
                :class="props.class"
            )
                slot(:name="props.name")
</template>

<script>
import Tab from './tab'
export default {
    name: 'Tabs',
    components: {
        Tab,
    },
    props: {
        tabsArray: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            tabs: [],
            alwaysShowTabs: false,
            getSelectedTabIndex: 0,
        }
    },
    mounted() {
        this.tabs = this.$refs.tabs
        // Start listening to scroll and setup the slide marker once the dom is fully ready
        this.$nextTick(function () {
            // Place marker on the first tab
            this.slideMarker(0)
        })
    },
    methods: {
        // Move the underline marker
        slideMarker(index) {
            // Move the marker to the tab that was just clicked. CSS will animate it.
            this.$refs.slide.style.width = this.$refs.links[index].offsetWidth + 'px'
            this.$refs.slide.style.left = this.$refs.links[index].offsetLeft + 'px'
        },
        selectTab(index) {
            this.getSelectedTabIndex = index
            this.slideMarker(index)
        },
    },
}
</script>

<style lang="stylus" scoped>
.tabs-header
    &.-fixed
        position: fixed
        top: 0
        z-index: theme('zIndex.50')
        border: none
        box-shadow: 0 3px 10px 0 rgba(153, 153, 153, 0.75)
        box-sizing: border-box
    .item
        transition: background-color 0.2s linear, color 0.3s linear
    &.-fixed ._onlyFixed
        display: inline-block !important
</style>
